export enum SortDirection {
  DESC = 'desc',
  ASC = 'asc',
}

export interface ISort {
  properties: string[]
  direction: SortDirection
}
